import { today } from '@internationalized/date';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAnalytics } from '@provider-directory/components/analytics/analytics-provider';
import { useOrgContext } from '@provider-directory/components/org-context/org-context-provider';

export interface ComplianceLink {
  onClick?: () => void;
  href?: string;
  analyticsText: string;
  text: string;
}

interface FooterComplianceLinksProps {
  complianceLinks: ComplianceLink[];
}

const todaysYear = today('EST').year;

export const FooterComplianceLinks: FC<FooterComplianceLinksProps> = ({
  complianceLinks,
}) => {
  const { key } = useOrgContext();
  const { t } = useTranslation(key);
  const analytics = useAnalytics();
  const handleClick = (link: ComplianceLink) => {
    link.onClick?.();

    analytics.navigationClickEvent({
      navigationType: 'footer',
      clickText: link.analyticsText,
      linkType: 'link',
    });
  };
  return (
    <div
      className={
        'md:space-y-16 lg:flex lg:items-center lg:justify-between lg:space-y-0 w-full space-y-32'
      }
    >
      <div
        className={
          'md:space-y-16 xl:flex xl:flex-row xl:items-baseline xl:justify-between xl:w-full xl:space-y-0 space-y-32'
        }
      >
        <ul className={'mf-footer__bottom__links'}>
          {complianceLinks.map((link, index) => {
            const hasRef = link.href;

            const content = (
              <span className={'mf-link__text'}>
                <span className={'mf-link__text__inner'}>{t(link.text)}</span>
              </span>
            );
            const linkClassName =
              'mf-link mf-link--site-montefiore mf-link--primary mf-link--base mf-link--no-underline mf-text-body-3-sans cursor-pointer font-serif';

            return (
              <li key={index}>
                {hasRef ? (
                  <a
                    className={linkClassName}
                    onClick={() => {
                      handleClick(link);
                    }}
                    href={link.href}
                    data-analytics-click-text={link.analyticsText}
                    data-analytics-link-type={'link'}
                  >
                    {content}
                  </a>
                ) : (
                  <button
                    className={linkClassName}
                    type={'button'}
                    data-analytics-click-text={link.analyticsText}
                    data-analytics-link-type={'link'}
                    onClick={() => {
                      handleClick(link);
                    }}
                  >
                    {content}
                  </button>
                )}
              </li>
            );
          })}
        </ul>
        <div className={'mf-footer__bottom__info'}>
          <p
            className={
              'mf-text-body-4-sans mf-text-gray-500 font-serif !leading-none'
            }
          >
            {`© ${todaysYear}  Montefiore Einstein`}
          </p>
        </div>
      </div>
    </div>
  );
};
